import { useQuery } from 'react-query';

import { LifelineResponse } from '@/features/customsPass/lifeline/types';
import { axios } from '@/lib/axios';

type QueryParams = {
  folderId: string;
};

function getLifelineItemsByFolderId({ folderId }: QueryParams) {
  return axios.get<LifelineResponse>(`/folders/${folderId}/life-line`);
}

export function useGetLifelineByFolderIdAsync({ folderId }: QueryParams) {
  return useQuery({
    queryKey: ['lifeline', folderId],
    queryFn: async () => {
      const { data } = await getLifelineItemsByFolderId({ folderId });
      return (data?.lifeLineEntries ?? []).reverse();
    },
    retry: 3,
    cacheTime: 0,
  });
}
